export default {
      id: "md_move-usage",
      viewBox: "0 0 15 9",
      url: __webpack_public_path__ + "img/icons.svg#md_move",
      toString: function () {
        return this.url;
      }
    }